import React from 'react';
import PropTypes from 'prop-types';
import control from '../../hocs/control/index';
import {noop} from 'lodash';
import TagsInput from 'components/tag-input/index';
//https://github.com/Lesha-spr/react-validation
class TagsInputs extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    const { error, onChange, onBlur, isUsed, onFocus, ...props } = this.props;
    let className = '';

    if (isUsed) {
      if (error) {
        className = `is-invalid-input ${props.className}`;
      } else {
        className = `is-valid-input ${props.className}`;
      }
    } else {
      className = `${props.className}`;
    }

    var id = 'vali-' + props.name;

    let { value, defaultValue } = props;

    if (defaultValue && (value === null || value === '')) {
      value = defaultValue;
    }

    return <div style={this.props.divStyle}>
      <TagsInput
        {...props}
        {...({ className: `${className}` }) }
        value={value}
        // inputProps={{ placeholder: 'MM/DD/YYYY' }}
        timeFormat={false}
        onChange={(data) => onChange({persist: noop, target: {value: data} })}
        //onBlur={(data) => onBlur({persist: noop, target: {value: data} })}
        inputProps= {{'onFocus': onFocus}}
        list="autocompleteOff"  
      />
      {isUsed && error && <span id={id} className='cls-danger help-block' style={{marginBottom: -15}}>{error}</span>}
    </div>;
  }
}

TagsInputs.propTypes = {
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  name: PropTypes.string,
  isUsed: PropTypes.bool,
  divStyle: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

export default control(TagsInputs);



// WEBPACK FOOTER //
// ./src/components/react-validation/components/tags-input/index.js